import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-09f53d0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-upload fw" }
const _hoisted_2 = {
  key: 0,
  class: "ub ub-ac mb15"
}
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 上传附件 ")
const _hoisted_4 = { class: "ub" }
const _hoisted_5 = { class: "text-grey ml15" }
const _hoisted_6 = { class: "ub ub-ac" }
const _hoisted_7 = { class: "file-upload-table" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 删除 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("下载")

export function render(_ctx, _cache) {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_file_status = _resolveComponent("file-status")
  const _component_hmd_empty_link = _resolveComponent("hmd-empty-link")
  const _component_download_file = _resolveComponent("download-file")
  const _component_table_wrapper = _resolveComponent("table-wrapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.allowEdit)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_a_upload, {
            "before-upload": _ctx.beforeUpload,
            "custom-request": _ctx.customRequest,
            multiple: true,
            "show-upload-list": false,
            name: "file"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                disabled: _ctx.disabled,
                loading: _ctx.uploading,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }, 8, ["disabled", "loading"])
            ]),
            _: 1
          }, 8, ["before-upload", "custom-request"]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, "（已选择" + _toDisplayString(_ctx.fileList?.length) + "个文件）", 1),
            _createElementVNode("small", _hoisted_6, "附件上限" + _toDisplayString(_ctx.maxCount) + "个，单个文件不得超过" + _toDisplayString(_ctx.maxSize) + "M", 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(_component_table_wrapper, {
        ref: "tableRef",
        class: _normalizeClass(_ctx.class),
        tableHeight: _ctx.fileList?.length>0?(_ctx.fileList.length+2)*34:34*5,
        dataSource: _ctx.fileList,
        columns: _ctx.columns,
        showCheckbox: false
      }, {
        size: _withCtx(({ record }) => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$filters.humanizeFileSize(record.size)), 1)
        ]),
        status: _withCtx(({ record }) => [
          _createVNode(_component_file_status, {
            status: record.status
          }, null, 8, ["status"])
        ]),
        action: _withCtx(({ record }) => [
          (_ctx.allowEdit)
            ? (_openBlock(), _createBlock(_component_hmd_empty_link, {
                key: 0,
                onClick: $event => (_ctx.deleteFile(record))
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["onClick"]))
            : _createCommentVNode("", true),
          _createVNode(_component_download_file, {
            url: record.url,
            fileName: record.name
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 2
          }, 1032, ["url", "fileName"])
        ]),
        _: 1
      }, 8, ["class", "tableHeight", "dataSource", "columns"])
    ])
  ]))
}